<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="5">
        <el-card class="box-card">

          <el-input type="textarea"
                    v-model="goodsIdText"
                    :rows="30"
                    placeholder="请输入商品短链接,多个商品请换行"></el-input>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-button icon="el-icon-search"
                   @click="generateLinks">解析</el-button>
        <el-divider></el-divider>
        <el-table :data="generatedLinksInfo"
                  stripe>
          <el-table-column prop="goodsId"
                           label="商品ID"></el-table-column>
          <el-table-column prop="shortUrl"
                           label="商品短链接"></el-table-column>
          <el-table-column prop="goodsUrl"
                           label="商品完整链接"></el-table-column>
          <el-table-column prop="goodsTitle"
                           label="商品标题"></el-table-column>
          <el-table-column prop="goodsCurrentPrice"
                           label="商品价格（券前）"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}
</style>
<script>
import axios from 'axios'

function queryStringToJSON(queryString) {
  if (queryString.indexOf("?") > -1) {
    queryString = queryString.split("?")[1];
  }
  var pairs = queryString.split("&");
  var result = {};
  pairs.forEach(function (pair) {
    pair = pair.split("=");
    result[pair[0]] = decodeURIComponent(pair[1] || "");
  });
  return result;
}



export default {
  name: "dyshortlink",
  data() {
    return {
      goodsId: '',
      goodsIds: [],
      goodsIdText: '',
      generatedLinksInfo: [],
      douyinCode: '',
      originUrl: ''
    };
  },
  methods: {
    copyUrl() {
      this.$clipboard(this.uploadedLink)
    },
    generateLinks() {
      const _self = this;
      if (this.goodsIdText === '') {
        alert('请输入商品短链接.')
        return;
      }

      this.goodsIds = this.goodsIdText.split('\n')
      if (this.goodsIdText.length === 0) {
        alert('请输入商品短链接.')
        return;
      } else {
        _self.processLink();
      }

    },
    processLink() {
      const _self = this;
      if (this.goodsIds.length > 0) {
        const processGoodsId = this.goodsIds.shift();
        axios.get("/api/getRedirectLink?link=" + processGoodsId)
          .then((content) => {

            if (content.data.indexOf("http") > -1) {
              const qsObj = queryStringToJSON(content.data)
              console.log(qsObj);


              if (
                qsObj &&
                qsObj.goods_detail &&
                qsObj.ecom_share_track_params
              ) {
                let shareDetailInfo = null;
                try {
                  shareDetailInfo = JSON.parse(
                    decodeURIComponent(qsObj.goods_detail)
                  );
                } catch (error) {
                  shareDetailInfo = null;
                }
                if (shareDetailInfo) {
                  console.log(shareDetailInfo);
                  let goodsInfo = {};
                  goodsInfo.shortUrl = processGoodsId;
                  goodsInfo.goodsId = qsObj.id;
                  goodsInfo.goodsUrl =
                    "https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=" +
                    qsObj.id +
                    "&h5_origin_type=detail_share_v2";
                  goodsInfo.goodsImages = shareDetailInfo.img.url_list[0];
                  goodsInfo.goodsCurrentPrice = shareDetailInfo.min_price / 100;
                  goodsInfo.goodsCalcPrice = goodsInfo.goodsCurrentPrice;
                  goodsInfo.goodsTitle = shareDetailInfo.title;
                  goodsInfo.goodsSaleCount = shareDetailInfo.sales;


                  _self.generatedLinksInfo.push(goodsInfo);
                  setTimeout(_self.processLink, 150)

                  console.log(goodsInfo);

                }
                try {
                  let goods_detail = JSON.parse(qsObj.goods_detail)
                  console.log(goods_detail);
                  let goodsInfo = {};
                  goodsInfo.shortUrl = processGoodsId;
                  goodsInfo.goodsId = qsObj.id;
                  goodsInfo.goodsUrl =
                    "https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=" +
                    qsObj.id +
                    "&h5_origin_type=detail_share_v2";
                  goodsInfo.goodsImages = goods_detail.img.url_list[0];
                  goodsInfo.goodsCurrentPrice = goods_detail.min_price / 100;
                  goodsInfo.goodsCalcPrice = goodsInfo.goodsCurrentPrice;
                  goodsInfo.goodsTitle = goods_detail.title;
                  goodsInfo.goodsSaleCount = goods_detail.sales;
                  _self.generatedLinksInfo.push(goodsInfo);
                  setTimeout(_self.processLink, 150)
                } catch (e) {
                  console.error(e);
                }
              }
            }

          });
      } else {
        alert('无待处理的商品链接');
      }
    },
  },
  mounted() {
  },
};
</script>
